/*LIBRARY*/
import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/
import information from "../../Assets/svg/information-circle.svg";
import arrow from "../../Assets/svg/arrow.svg";

/*FUNCTION*/

/*DATA*/
import domain_list from "../../Data/domain_list";
import dict from "../../Data/dict.json";

/*CONST*/

class GeomapidVersion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_version: false,
    };
  }

  toggle_version = () => {
    const { modal_version } = this.state;
    this.setState({
      modal_version: !modal_version,
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    const { title, subtitle, auth, is_mobile } = this.props;
    const { version, last_update } = auth;

    //content
    const is_login_kai = domain_list?.[auth?.domain]?.is_login_kai;

    return (
      <main className="auth_content_left w_350">
        <div>
          <label className="flex">
            <div className="flex gap_5">
              {title}
              <div
                className="tooltip flex align_center"
                data-tooltip={dict["One Platform to Connect All Spatial Data"][language]}
              >
                <img
                  className="info_icon "
                  src={information}
                  alt="What's new"
                />
              </div>
            </div>
          </label>
          {!is_mobile && <label>{subtitle}</label>}

          <section>
            <p className="flex wrap">
              {!is_login_kai ? `${dict?.["Version"]?.[language]} ${version}` :
                `Update: ${last_update}`}
            </p>
            <label className="padding_x_5">{" . "}</label>
            <Link
              className="center_perfect bold text_white"
              to={{ pathname: "https://mapid.co.id" }}
              target="_blank"
              rel="noopener noreferer"
            >
              <p>
                <u>About Us</u>
              </p>{" "}
              <img src={arrow} alt="Landing Page" />
            </Link>
          </section>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(GeomapidVersion);
